import { Component, ojs, app, payload, v } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { pageInfo, each, either, formatDateForHumans, empty, inform, eParse } from "../../helpers";
import { PAGES, STRINGS } from "../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");
const ac = app("ac");
const gc = app("gc");
const dc = app("dc");
const router = app("router");

export default class ProcessOrder extends Component {
	render(...args) {
		pageInfo(PAGES.PROCESS_ORDERS);

		ac.actions.value = "order-filter-actions";

		return h.div(
			v(ac.orders, (state) => {
				return h.div(
					{ class: "my-2 d-flex flex-wrap gap-2" },
					each(Object.keys(dc.orderFilters.statuses), (key) =>
						h.span(
							{
								class: "badge rounded-pill text-dark bg-light border",
							},
							`status: ${key}`
						)
					)
				);
			}),

			h.div(
				{ class: "position-relative py-md-5" },
				h.div(
					{ class: "d-none d-lg-flex mb-3" },
					h.button(
						{
							class: "btn btn-light d-flex gap-2",
							onclick: () => broker.send($e.ui.needs.actionsForm),
						},
						h.span(
							{ class: "icon" },
							h.i({ class: "fas fa-sliders" })
						),
						"Filter"
					)
				),

				h.div(
					{ class: "d-grid gap-3", style: "padding-bottom: 15rem;" },

					v(ac.orders, (catalog) => {
						return either(
							Object.keys(catalog.value).length < 1,
							() =>
								h.div(
									{ class: "card" },
									h.div(
										{ class: "card-body text-center" },
										h.span(
											{ class: "text" },
											"No orders found for the selected status"
										)
									)
								)
						);
					}),

					v(ac.orders, (catalog) => {
						return each(catalog.value, (order) => {
							const user = order?.user;

							return h.div(
								{
									class: "border border-3 card mb-4 shadow-none",
								},

								h.div(
									{
										class: "card-body",
										role: "button",
										onclick: this.method(
											"openOrderDetails",
											order?.id
										),
									},

									h.div(
										{ class: "d-flex flex-column p-0" },
										h.span(
											{
												class: "text d-flex gap-2 align-items-center",
											},
											h.span(
												"Order Code: ",
												order?.order_code
											),
											either(
												order?.type == "errand",
												() =>
													h.span(
														{
															class: "badge rounded-pill bg-secondary",
														},
														"Work"
													)
											),
											v(
												dc.orderItemsMapping,
												(mapping) => {
													let o =
														mapping.value[order.id];

													if (
														!o ||
														Object.keys(o).length ==
															0
													)
														return null;

													return h.span(
														{
															class: "icon text-success ms-2",
														},
														h.i({
															class: "fas fa-circle",
														})
													);
												}
											)
										),

										h.small(
											"By: ",
											user?.first_name,
											" ",
											user?.last_name
										),
										h.small(
											{ class: "fw-400" },
											"At: ",
											formatDateForHumans(
												order?.created_at
											)
										),

										either(
											order?.status != "completed" &&
												order?.status != "cancelled",
											() => {
												let now =
													new Date().getTime() / 1000;
												let due =
													new Date(
														order?.delivered_at
													).getTime() / 1000;

												let badge = h.span(
													{
														class: "badge bg-success text-white",
													},
													"in-time"
												);
												let textClass = "text-success";

												let diff = (due - now) / 60;

												if (diff < 0) {
													badge = h.span(
														{
															class: "badge bg-danger text-white",
														},
														"late"
													);
													textClass = "text-danger";
												} else if (diff <= 10) {
													badge = h.span(
														{
															class: "badge bg-warning text-white",
														},
														"due"
													);
													textClass = "text-danger";
												} else if (diff <= 15) {
													badge = h.span(
														{
															class: "badge bg-info text-white",
														},
														"due-soon"
													);
												}

												return h.span(
													{ class: "fs-xsm fw-600" },
													"Due: ",
													h.span(
														{ class: textClass },
														formatDateForHumans(
															order?.delivered_at
														),
														" ",
														badge
													)
												);
											}
										)
									)
								),
								either(
									order?.status != "completed" &&
										order?.status != "cancelled",
									() =>
										h.div(
											{ class: "card-footer px-3 py-2" },

											h.div(
												{
													class: "d-flex justify-content-between gap-2",
												},
												this.renderMovementButton(
													order?.previous_status,
													"previous",
													order?.id
												),

												h.div(
													{
														class: "d-flex gap-3 align-items-center",
													},

													this.renderMovementButton(
														order?.next_status,
														"next",
														order?.id
													),

													h.span(
														h.input({
															type: "checkbox",
															onclick:
																this.method(
																	"selectOrder",
																	[order?.id]
																),
															class: "form-check-input m-0",
															style: "width: 27px; height: 27px;",
														})
													)
												)
											)
										)
								)
							);
						});
					})
				),

				h.div(
					{
						class: "move-selected-orders fixed-bottom",
						style: "z-index: 1035;",
						id: "mass-action-cta-btn",
					},

					v(dc.selectedItems, (selectedItems) => {
						if (Object.keys(selectedItems.value).length < 1)
							return null;

						return h.div(
							{ class: "card shadow rounded-pill mx-2 my-3" },

							h.div(
								{
									class: "card-body",
									onclick: this.method("purchaseItems"),
								},

								h.span(
									{
										class: "d-flex gap-2 align-items-center justify-content-center text-success fw-500 fs-4",
									},

									h.i({
										class: "fas fa-hand-holding-dollar",
									}),

									h.span(
										"Purchase ",
										Object.keys(selectedItems.value).length,
										" Item" +
											`${
												Object.keys(selectedItems.value)
													.length > 1
													? "s"
													: ""
											}`
									)
								)
							)
						);
					}),

					v(dc.selectedOrders, (selectedOrders) => {
						if (Object.keys(selectedOrders.value).length < 1)
							return null;

						return h.div(
							{ class: "card shadow rounded-pill mx-2 my-3" },

							h.div(
								{ class: "card-body" },

								h.div(
									{
										class: "d-flex align-items-center justify-content-between",
									},

									h.button(
										{
											type: "button",
											class: "btn btn-cta",
											onclick: this.method(
												"moveMany",
												"previous"
											),
										},

										h.i({ class: "fas fa-arrow-left" })
									),

									h.span(
										{
											class: "d-flex gap-2 align-items-center",
										},
										h.i({ class: "fas fa-circle-dot" }),
										h.span("Move Orders"),
										h.i({ class: "fas fa-circle-dot" })
									),

									h.button(
										{
											type: "button",
											class: "btn btn-cta",
											onclick: this.method(
												"moveMany",
												"next"
											),
										},

										h.i({ class: "fas fa-arrow-right" })
									)
								)
							)
						);
					})
				),
				...args
			)
		);
	}

	openOrderDetails(orderId, status) {
		broker.send($e.order.needs.refresh, payload({ orderId }));

		return broker.send($e.order.needs.processForm, payload({ orderId }));
	}

	renderMovementButton(info, type, orderId, ...args) {
		if (Object.keys(info).length == 0) return null;

		switch (type) {
			case "next": {
				return h.button(
					{
						class: "btn btn-sm text-uppercase border-transparent text-success fw-500",
						onclick: this.method("changeStatus", [
							orderId,
							info.url,
							"next",
							info.name,
						]),
					},

					h.span(
						{ class: "mx-2" },

						info.name
					),
					h.i({ class: "fas fa-arrow-right" })
				);
			}
			case "previous": {
				return h.button(
					{
						class: "btn btn-sm text-uppercase border-transparent text-primary fw-500",
						style: "margin-left: -5px;",
						onclick: this.method("changeStatus", [
							orderId,
							info.url,
							"previous",
						]),
					},

					h.i({ class: "fas fa-arrow-left" }),
					h.span(
						{ class: "mx-2" },

						info.name
					)
				);
			}
		}
	}

	changeStatus(orderId, url, stage, statusName = null) {
		if (url == null) return;

		broker.send(
			$e.order.needs.statusChange,
			payload({ orderId, url, stage, statusName })
		);
	}

	selectItem(elem, item) {
		if (!empty(item.hashtags)) {
			let oneChosen = false;

			for (let tag of item.hashtags) {
				if (dc.selectedHashtags[tag.name]) {
					oneChosen = true;
					break;
				}
			}

			if (!oneChosen) {
				return inform(
					"Please select at least one category before buying this item",
					STRINGS.ERROR
				);
			}
		}

		elem.querySelector(`i`)?.classList.toggle("fas");
		elem.querySelector(`i`)?.classList.toggle("far");

		let selected = elem.querySelector(`i`)?.classList.contains("fas");

		let items = tool.deepCopy(dc.selectedItems.value);
		let orders = tool.deepCopy(dc.orderItemsMapping.value);

		if (!(item.order_id in orders)) {
			orders[item.order_id] = {};
		}

		if (selected) {
			items[item.id] = item;
			orders[item.order_id][item.id] = item;
		} else {
			delete items[item.id];
			delete orders[item.order_id][item.id];
		}

		dc.orderItemsMapping.value = orders;
		dc.selectedItems.value = items;
	}

	selectOrder(orderId) {
		let orders = tool.deepCopy(dc.selectedOrders.value);
		let selected = !(orderId in orders);

		if (selected) {
			orders[orderId] = true;
		} else {
			delete orders[orderId];
		}

		dc.selectedOrders.value = orders;

		broker.send($e.app.has.selectedOrders);
	}

	moveMany(direction) {
		broker.send($e.order.needs.massStatusChange, payload({ direction }));
	}

	purchaseItems() {
		broker.send($e.purchase.needs.creation);
	}

	viewPurchase(purchaseId) {
		broker.send($e.purchase.needs.display, payload({ purchaseId }));
	}

	setPurchasePrice(elem, itemId) {
		if (elem.value.length < 1 && elem.value <= 0) {
			delete dc.purchasePrices.value[itemId];
		} else {
			dc.purchasePrices.value[itemId] = elem.value;
		}
	}

	$$ojs = {
		routeChanged: (ed, event) => {
			if (!router.is("rider-orders")) return;

			let filter = { ...dc.orderFilters.value };
			filter.deliverers = [gc.user.value?.id || window.currentUser?.id];
			filter.statuses = Object.keys(dc.orderFilters.statuses);
			filter.orderBy = [filter.orderColumn, filter.orderBy ?? "desc"];

			delete filter.multipleStatuses;
			delete filter.orderColumn;

			broker.send($e.order.needs.catalog, payload({ filter }));
		},
	};

	$$app = {
		has: {
			selectedOrderItems_selectedOrders: (ed, event) => {
				let catBtn = dom.id("mass-action-cta-btn");

				let show =
					!empty(dc.selectedOrders.value) ||
					!empty(dc.selectedItems.value);

				if (show) {
					catBtn?.classList.add("show");
				} else {
					catBtn?.classList.remove("show");
				}
			},
		},
	};

	$$purchase = {
		is: {
			confirming: (ed, event) => {
				let data = eParse(ed);

				if (data.meta.type == "errand") return;

				let items = data.message.get("itemsPurchased", {});

				for (const id in items) {
					h.div(
						{
							class: "h-100 d-flex justify-content-center gap-1",
							id: `order-item-${id}-select-holder`,
							parent: dom.id(`order-item-${id}-select-holder`),
							replaceParent: true,
						},
						h.span(
							{
								class: "btn-cta btn-cta-success",
							},
							h.i({ class: "fas fa-ellipsis" })
						)
					);
				}
			},
		},

		failed_completed: (ed, event) => {
			let data = eParse(ed);
			if (data.meta.type == "errand") return;
			let items = data.message.get("itemsPurchased", {});

			for (const id in items) {
				let item = items[id];

				h.div(
					{
						class: "text-success",
						id: `order-item-${item?.id}-select-holder`,
						parent: dom.id(`order-item-${id}-select-holder`),
						replaceParent: true,
						onclick: this.method("selectItem", [
							"${dom.id(" +
								`'order-item-${item?.id}-select'` +
								")}",
							item,
						]),
					},
					h.span(
						{
							class: "text-success",
							id: `order-item-${item?.id}-select`,
						},
						either(
							item?.id in dc.selectedItems.value,
							h.SolidIcon("square"),
							h.Icon("square")
						)
					),
					" ",
					either(
						item?.id in dc.selectedItems.value,
						h.span("Selected"),
						h.span("Buy")
					)
				);

				if (event == $e.purchase.completed) {
					let ip = dom.id(`order-item-purchase-price-${id}`);
					if (ip) ip.value = "";
				}
			}
		},
	};
}